import React from 'react';
const MockSessionContext = React.createContext(null);
export default MockSessionContext;